import React from 'react';

import { RouteInterface } from 'routes';
import GenericListRoute from 'routes/generic/list';

import { DenormalizedAssetClassification } from 'store/data';

interface Props {
  routes: RouteInterface[];
}

const List: React.FC<Props> = ({ routes }) => {
  return (
    <GenericListRoute<DenormalizedAssetClassification>
      resolver="assetClassifications"
      itemName="asset classification"
      listItemTitle={entity => entity.label}
      listTitle="Asset classifications"
      detailRoute="asset-classification"
      detailIdParam="assetClassificationId"
      createRoute="asset-classifications:create"
      dependencies={[]}
      routes={routes}
      showListTitle={true}
    />
  );
};

export default List;
